
export default {
    'Gutter': {
        Mobile: 20,
        Tablet: 40,
        Laptop: 40,
        Desktop: 40,
    },
    'headerHeight': {
        Mobile: 95,
        Tablet: 116,
        Laptop: 116,
        Desktop: 116,
    },
    'websiteMaxWidth': 1024
};


// WEBPACK FOOTER //
// ./src/constants/spacing.ts